
import dating_viewHistory from '@/views/homePage/menu/suoshuidan_dating/components/viewHistory.vue'
export default {
	path: '/dating_viewHistory',
	name: 'dating_viewHistory',
	component: dating_viewHistory
}